import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from '@lt/localization';
import HotelRating from 'src/components/HotelRating';
import HotelRelink from '../HotelRelink';
import ReviewsList from '../../containers/Reviews/ReviewsList';
import Paper from '../Paper';

import styles from './reviews.module.css';

const ReviewsDesktop = ({
  isRatingExists,
  linkedHotels,
  searchParams,
  isWhitelabel,
}) => {
  const showLinkedHotels = !isWhitelabel && linkedHotels.length > 0;
  const { t } = useTranslation();

  return (
    <div className={styles.ltHotelReviews}>
      <h2 className="like-h2">{t('hotel.reviews.title')}</h2>
      <div className={styles.ltHotelReviewsRow}>
        <div className={styles.ltHotelReviewsList}>
          <div className="lt-hotel-reviews-items">
            <ReviewsList />
          </div>
        </div>
        {(isRatingExists || showLinkedHotels) && (
          <div className={styles.rating}>
            <HotelRating />
            {showLinkedHotels && (
              <Paper>
                <div className={styles.heading}>{t('hotel.similarHotels')}</div>
                <HotelRelink
                  hotels={linkedHotels}
                  searchParams={searchParams}
                />
              </Paper>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

ReviewsDesktop.propTypes = {
  isRatingExists: PropTypes.bool.isRequired,
};

export default ReviewsDesktop;
